import * as React from 'react'
import { SVGProps } from 'react'
const SvgVideoPlayButton = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 294.843 294.843" {...props}>
    <path d="M278.527 79.946c-10.324-20.023-25.38-37.704-43.538-51.132a6.001 6.001 0 0 0-7.135 9.649c16.687 12.34 30.521 28.586 40.008 46.983 9.94 19.277 14.98 40.128 14.98 61.976 0 74.671-60.75 135.421-135.421 135.421S12 222.093 12 147.421 72.75 12 147.421 12a6 6 0 0 0 0-12C66.133 0 0 66.133 0 147.421s66.133 147.421 147.421 147.421 147.421-66.133 147.421-147.421c0-23.444-5.641-46.776-16.315-67.475z" />
    <path d="M109.699 78.969a6.002 6.002 0 0 0-3.035 5.216v131.674a6 6 0 0 0 12 0V94.74l88.833 52.883-65.324 42.087a6 6 0 1 0 6.5 10.087l73.465-47.333a6 6 0 0 0-.181-10.2L115.733 79.029a6 6 0 0 0-6.034-.06z" />
  </svg>
)
export default SvgVideoPlayButton
